import React from 'react'
import { TagModel } from '../../../model/tag.model'
import './TagTree.css'
interface TagTreeProps {
    parentTags?: TagModel[]
    childTags?: TagModel[]
    selectedParentTag?: TagModel | null
    selectedChildTag?: TagModel | null
    onSelectParentTag?: (tag: TagModel) => void
    onSelectChildTag?: (tag: TagModel) => void
    onFilterChange?: (tag: TagModel) => void
}
const TagTree: React.FC<TagTreeProps> = (props) => {
    const {
        parentTags,
        childTags = [],
        onSelectParentTag = () => undefined,
        selectedParentTag,
        selectedChildTag,
        onFilterChange = () => undefined,
        onSelectChildTag = () => undefined,
    } = props
    if (!parentTags) {
        return null
    }
    return (
        <div className='tags-tree'>
            <div className='parent-tags tag-list'>
                {parentTags.map((item, index) => (
                    <div
                        key={item.ktag_id}
                        className={`tag-cell ellipsis ${
                            selectedParentTag &&
                            selectedParentTag.ktag_id === item.ktag_id
                                ? 'active'
                                : ''
                        }`}
                        onClick={() => {
                            console.log(item)
                            if (
                                item.ktag_name === '全部' ||
                                !item.has_children
                            ) {
                                onFilterChange({ ...item })
                            }
                            onSelectParentTag(item)
                        }}
                    >
                        {index === 0
                            ? `全部(${item.count})`
                            : `${item.ktag_name}(${item.count})`}
                    </div>
                ))}
            </div>
            <div className='child-tags tag-list'>
                {childTags.map((item, index) => (
                    <div
                        key={item.ktag_id}
                        className={`tag-cell ellipsis ${
                            selectedChildTag &&
                            selectedChildTag.ktag_id === item.ktag_id
                                ? 'active'
                                : ''
                        }`}
                        onClick={() => {
                            onFilterChange(item)
                            onSelectChildTag(item)
                        }}
                    >
                        {item.ktag_name}({item.count})
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TagTree
